import { Topic } from "../../models/Topic";
import { UPSERT_TOPICS } from "./actionTypes";

export const upsertTopics = (topics: Array<Topic>) => {
    return {
        type: UPSERT_TOPICS,
        payload: topics
    };
};